import React, { useContext, useEffect, useState, useRef } from "react";
import CodeMirror, { EditorView } from "@uiw/react-codemirror";
import { PrimaryButton, SecondaryButton } from "../UI";
import EditConfigJson from "../Template/EditConfigJson";

import Loader from "../UI/Loader/Loader";
import SuccessAlert from "../UI/Alert/SuccessAlert";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "../UI/ResizeablePanel/ResizeablePanel";
import { DeviceEmulator, DeviceFrameset } from "react-device-frameset";
import { BracesIcon, CodeXmlIcon, EditIcon, FileJsonIcon } from "lucide-react";
import Dropdown from "../UI/Dropdown/Dropdown";
import { GlobalTemplateContext } from "../../contexts/GlobalTemplateContext";
import CreateTemplateLevelModal from "./CreateTemplateLevelModal";
import { useParams } from "react-router-dom";
import Toggle from "../UI/Toggle";
import { useContentfulContext } from "../../contexts/ContentfulContext";
import HtmlViewerWithInspector from "../Template/HtmlViewerWithInspector";

const PreviewTemplate = ({
  templateName,
  templateIconURL,
  setTemplateIconURL,
  cssCode,
  setCssCode,
  htmlCode,
  setHtmlCode,
  configJsonCode,
  setConfigJsonCode,
  jsonSchemaCode,
  setJsonSchemaCode,
  selectedTemplate,
  setTemplateName,
  validateTemplateName,
  templateError,
  submitError,
  saveTemplateHandler,
  selectedTemplateId,
  templateType,
  setTemplateType,
  templatePlatform,
  setTemplatePlatform,
  isLandscapeSupport,
  setIsLandscapeSupport,
  levels,
  setLevels,
  templateSource,
  setTemplateSource,
  apiEndPoint,
  setApiEndPoint,
  validateURL,
}) => {
  const previewIframeRef = useRef(null);
  const { setData, data } = useContext(GlobalTemplateContext);
  const { id } = useParams();
  const { enums, content } = useContentfulContext();

  const [showEditJSON, setShowEditJSON] = useState(false);
  const [codeType, setCodeType] = useState(templateType === enums?.templateTypes.no_preview.id ? "config_json" : "html");
  const [showEditor, setShowEditor] = useState(true);

  const [loading, ] = useState(false);
  const [error, ] = useState(false);
  const [success, ] = useState("");
  const [levelModal,setLevelModal] = useState(false)

  const formatIFrameData = ({ htmlCode, cssCode, jsonCode }) => ({
    code: {
      html: `function(template) { return \`${htmlCode}\` }`,
      styles: cssCode,
    },
    base_config_json: JSON.parse(jsonCode),
    experience_json: getExperienceJSON(JSON.parse(jsonCode)),
  });

  const handleTemplateChanges = () => {
    const newData = { ...data };
    newData[templateName] = formatIFrameData({ htmlCode, cssCode, jsonCode: configJsonCode });
    setData(newData);

    setShowEditor(true);
    setShowEditJSON(false);
  };

  const getExperienceJSON = (base_config_json) => {
    const experience_json = {};
    base_config_json.forEach(function (item, index) {
      experience_json[item.id] = item.input.input_default_value;
    });
    return transformExperienceJSON(experience_json);
  };

  function transformExperienceJSON(json) {
    const transformedJSON = {};
    for (const key in json) {
      const keys = key.split('.');
      keys.reduce((acc, part, index) => {
        if (part.includes('[')) {
          const [arrayKey, arrayIndex] = part.split(/\[|\]/).filter(Boolean);
          if (!acc[arrayKey]) {
            acc[arrayKey] = [];
          }
          if (!acc[arrayKey][arrayIndex]) {
            acc[arrayKey][arrayIndex] = {};
          }
          if (index === keys.length - 1) {
            acc[arrayKey][arrayIndex] = json[key];
          }
          return acc[arrayKey][arrayIndex];
        } else {
          if (index === keys.length - 1) {
            acc[part] = json[key];
          } else {
            if (!acc[part]) {
              acc[part] = {};
            }
            return acc[part];
          }
        }
      }, transformedJSON);
    }
    return transformedJSON;
  }

  const handleSaveTemplate = ()=>{
    if(id || (selectedTemplateId.length > 0) ){
      saveTemplateHandler()
    }else{
        setLevelModal(true);
      }
    }

  return (
    <div
      className="w-full"
      // className={`w-full ${
      //   isSideBarExpand ? "max-w-[1750px]" : "max-w-[1500px]"
      // } mx-auto overflow-auto `}
    >
      {success && (
        <SuccessAlert disappearTime={5000}>
          {content.CREATE_EXPERIENCE.success}
        </SuccessAlert>
      )}
      {loading && <Loader />}
      <ResizablePanelGroup direction="horizontal">
        <ResizablePanel defaultSize={30} minSize={20} className="h-auto">
          <div className="border-r-2 pt-5 pr-5 border-gray-3 h-full space-y-4">
            {/* <h1 class="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">
              {selectedTemplateId ? "Edit Template" : "Create Template"}
            </h1> */}
            <div className="w-full flex items-start flex-col gap-2 ">
              <div className="w-full">
                <div className="flex justify-between flex-wrap gap-4">
                  <div class="relative max-w-md w-full">
                    <input
                      type="text"
                      id="template_name"
                      name="template_name"
                      class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                      placeholder=" "
                      value={templateName}
                      onChange={(e) => {
                        setTemplateName(e.target.value);
                      }}
                      onBlur={validateTemplateName}
                    />
                    <label
                      for="template_name"
                      class="absolute text-sm text-black bg-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] rounded-md px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.form.name}
                    </label>
                  </div>

                  {((templatePlatform == enums?.templatePlatforms.mobile_only.id) || (templatePlatform == enums?.templatePlatforms.responsive.id)) && (
                    <div className="relative max-w-md w-full">
                      <input
                        type="text"
                        id="template_icon_url_mobile_only"
                        name="template_icon_url_mobile_only"
                        className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                        placeholder=" "
                        value={templateIconURL.mobile_only}
                        onChange={(e) => setTemplateIconURL((prev) => ({ ...prev, mobile_only: e.target.value }))}
                      />
                      <label
                        htmlFor="template_icon_url_mobile_only"
                        className="absolute text-sm text-black bg-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] rounded-md px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.form.icon_url_mobile_only}
                      </label>
                    </div>
                  )}

                  {((templatePlatform == enums?.templatePlatforms.web_only.id) || (templatePlatform == enums?.templatePlatforms.responsive.id)) && (
                    <div className="relative max-w-md w-full">
                      <input
                        type="text"
                        id="template_icon_url_web_only"
                        name="template_icon_url_web_only"
                        className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                        placeholder=" "
                        value={templateIconURL.web_only}
                        onChange={(e) => setTemplateIconURL((prev) => ({ ...prev, web_only: e.target.value }))}
                      />
                      <label
                        htmlFor="template_icon_url_web_only"
                        className="absolute text-sm text-black bg-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] rounded-md px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.form.icon_url_web_only}
                      </label>
                    </div>
                  )}

                  <div className="relative max-w-52 w-full flex gap-2 items-center">
                    <p className="absolute text-sm text-black bg-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] rounded-md px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                      {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.type}
                    </p>
                    <Dropdown
                      disabled={(selectedTemplate?.scope == enums?.templateScopes.global.id)}
                      initialValue={selectedTemplate && enums?.templateTypesArray.find((x) => x.id === selectedTemplate.type)}
                      items={enums?.templateTypesArray}
                      callback={(val) => setTemplateType(val.id)}
                    />
                  </div>

                  <div className="relative max-w-52 w-full">
                    <p className="absolute text-sm text-black bg-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] rounded-md px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                      {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.platform}
                    </p>
                    <Dropdown
                      initialValue={selectedTemplate ? enums?.templatePlatformArray.find((x) => x.id === selectedTemplate.platform) : enums?.templatePlatformArray.find((x) => x.id === enums?.templatePlatforms.responsive.id)}
                      items={enums?.templatePlatformArray}
                      callback={(val) => setTemplatePlatform(val.id)}
                    />
                  </div>

                  <div className="flex items-center gap-2 px-3 py-2 bg-white rounded-lg border border-stride-border shadow-sm">
                    <span className="text-xs font-semibold text-stride-heading">
                      {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.landscape_support}
                    </span>
                    <Toggle
                      id="global-template-landscape-toggle"
                      checked={isLandscapeSupport}
                      onChange={(e) => setIsLandscapeSupport(e.target.checked)}
                      size="sm"
                    />
                  </div>

                  <div className="relative max-w-52 w-full">
                    <p className="absolute text-sm text-black bg-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] rounded-md px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                      {content.MANAGE_GLOBAL_TEMPLATE_CONTENT.source}
                    </p>
                    <Dropdown
                      disabled={(selectedTemplate?.scope == enums?.templateScopes.global.id)}
                      initialValue={selectedTemplate && enums?.templateSourcesArray.find((x) => x.id === selectedTemplate.source)}
                      items={enums?.templateSourcesArray}
                      callback={(val) => setTemplateSource(val.id)}
                    />
                  </div>
                  {templateSource == enums?.templateSources.api.id && <div class="relative max-w-md w-full">
                    <input
                      type="text"
                      id="api_end_point"
                      name="api_end_point"
                      class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-2 appearance-none focus:outline-none focus:ring-1 focus:ring-primary-2 ring-primary peer"
                      placeholder=" "
                      value={apiEndPoint}
                      onChange={(e) => {
                        setApiEndPoint(e.target.value);
                      }}
                      onBlur={validateURL}
                    />
                    <label
                      for="template_name"
                      class="absolute text-sm text-black bg-white duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] rounded-md px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                    >
                      {selectedTemplateId ? "Update" : "Enter"} API Endpoint *
                    </label>
                  </div>}

                  {/* <div className="mr-1">
                    <Dropdown
                      initialValue={selectedTemplate && templateTypesArray.find((x) => x.id === selectedTemplate.type)}
                      items={templateTypesArray}
                      callback={(val) => setTemplateType(val.id)}
                    />
                  </div> */}
                  <div className="mr-1">
                    <PrimaryButton handleClick={handleSaveTemplate} size="sm">
                      Save template
                    </PrimaryButton>
                  </div>
                </div>
                {templateError ? (
                  <p class="mt-2 text-sm text-red-5">
                    {templateError}
                  </p>
                ) : null}
                {submitError ? (
                  <p class="mt-2 text-sm text-red-5">
                    {submitError}
                  </p>
                ) : null}
              </div>
            </div>
            <div className="flex space-x-4 justify-between items-center w-full">
              {/* <SecondaryButton handleClick={() => {
              setShowEditor(!showEditor);
              setShowEditJSON(false);
            }}>{content.EDIT_EXPERIENCE.edit_code_btn}</SecondaryButton> */}
              {/* <SecondaryButton handleClick={() => {
              setShowEditJSON(!showEditJSON);
              setShowEditor(false);
            }}>{content.EDIT_EXPERIENCE.edit_json_btn}</SecondaryButton> */}
            </div>
            {showEditJSON && (
              <EditConfigJson
                configJsonCode={configJsonCode}
                jsonSchemaCode={jsonSchemaCode
                  .replaceAll(
                    "&lt;",
                    "<"
                  )
                  ?.replaceAll(
                    "&gt;",
                    ">"
                  )}
                setConfigJsonCode={setConfigJsonCode}
                closeEditConfigJsonModal={() => setShowEditJSON(false)}
              />
            )}
            {showEditor && (
              <div class="h-full mb-4">
                <div className="w-full items-center py-1 flex-wrap gap-4 bg-white">
                  <div class="flex flex-col -mb-px text-sm font-medium">
                    <button type="button" class={`flex items-center justify-between w-full p-2 font-medium rtl:text-right text-gray-500 border border-gray-200 gap-3 ${ codeType === "html" ? 'text-primary border-primary' : 'border-gray-200' }`} onClick={() => {
                      setCodeType((prev) => {
                        return prev !== 'html' ? 'html' : ''; 
                      });
                    }}>
                      <span class="flex items-center">
                        <CodeXmlIcon height={18} />
                        {content.EDIT_EXPERIENCE.html_tab}
                      </span>
                      <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                      </svg>
                    </button>
                    { codeType == "html" && <div className="overflow-auto text-wrap">
                      <CodeMirror
                        value={htmlCode}
                        readOnly={false}
                        onChange={(code) => {
                          setHtmlCode(code);
                        }}
                        height="calc(100vh - 425px)"
                        width="100%"
                        lineWrapping={true}
                        lineNumbers={true}
                        extensions={[EditorView.lineWrapping]}
                      />
                    </div> }
                    <button type="button" class={`flex items-center justify-between w-full p-2 font-medium rtl:text-right text-gray-500 border border-gray-200 gap-3 ${ codeType === "css" ? 'text-primary border-primary' : 'border-gray-200' }`} onClick={() => {
                      setCodeType((prev) => {
                        return prev !== 'css' ? 'css' : ''; 
                      });
                    }}>
                      <span class="flex items-center">
                        <BracesIcon height={18} />
                        {content.EDIT_EXPERIENCE.css_tab}
                      </span>
                      <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                      </svg>
                    </button>
                    { codeType == "css" && <div className="overflow-auto text-wrap">
                      <CodeMirror
                        value={cssCode}
                        readOnly={false}
                        onChange={(code) => {
                          setCssCode(code);
                        }}
                        height="calc(100vh - 425px)"
                        width="100%"
                        lineWrapping={true}
                        extensions={[EditorView.lineWrapping]}
                      />
                    </div> }
                    <button type="button" class={`flex items-center justify-between w-full p-2 font-medium rtl:text-right text-gray-500 border gap-3 ${ codeType === "config_json" ? 'text-primary border-primary' : 'border-gray-200' }`} onClick={() => {
                      setCodeType((prev) => {
                        return prev !== 'config_json' ? 'config_json' : ''; 
                      });
                    }}>
                      <span class="flex items-center">
                        <FileJsonIcon height={18} />
                        {content.EDIT_EXPERIENCE.config_json_tab}
                        <button
                          className="ml-2 p-1 rounded-full hover:bg-gray-100 transition-colors"
                          id="template-config-json-edit-icon"
                          onClick={e => {
                            e.stopPropagation();
                            setShowEditJSON(true);
                          }}
                        >
                          <EditIcon
                            height={16}
                          />
                        </button>
                      </span>
                      <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                      </svg>
                    </button>
                    { codeType == "config_json" && <div className="overflow-auto text-wrap">
                      <CodeMirror
                        value={configJsonCode}
                        onChange={(code) => {
                          setConfigJsonCode(code);
                        }}
                        height="calc(100vh - 425px)"
                        width="100%"
                        lineWrapping={true}
                        extensions={[EditorView.lineWrapping]}
                      />
                    </div> }
                    <button type="button" class={`flex items-center justify-between w-full p-2 font-medium rtl:text-right text-gray-500 border border-gray-200 gap-3 ${ codeType === "json_schema" ? 'text-primary border-primary' : 'border-gray-200' }`} onClick={() => {
                      setCodeType((prev) => {
                        return prev !== 'json_schema' ? 'json_schema' : ''; 
                      });
                    }}>
                      <span class="flex items-center">
                        <FileJsonIcon height={18} />
                        {content.EDIT_EXPERIENCE.json_schema_tab}
                      </span>
                      <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                      </svg>
                    </button>
                    { codeType == "json_schema" && <div className="overflow-auto text-wrap">
                      <CodeMirror
                        value={jsonSchemaCode.replaceAll('&lt;', '<')?.replaceAll('&gt;', '>')}
                        readOnly={(templateSource == enums?.templateSources.api.id) ? true : false}
                        editable={(templateSource == enums?.templateSources.api.id) ? false : true}
                        onChange={(code) => {
                          setJsonSchemaCode(code.replaceAll('&lt;', '<')?.replaceAll('&gt;', '>'));
                        }}
                        height="calc(100vh - 425px)"
                        width="100%"
                        lineWrapping={true}
                        extensions={[EditorView.lineWrapping]}
                      />
                    {/* </div> : <div className="overflow-auto text-wrap"> 
                      <CodeMirror
                        value={jsonBSchemaCode}
                        onChange={(code) => {
                          console.log('code----------', code)
                          setJsonBSchemaCode(code);
                        }}
                        height="75vh"
                        width="100%"
                        lineWrapping={true}
                        extensions={[EditorView.lineWrapping]}
                      /> */}
                    </div> }
                  </div>
                  <div className="py-2">
                    <SecondaryButton handleClick={handleTemplateChanges} size="sm">
                      {content.EDIT_EXPERIENCE.save_btn}
                    </SecondaryButton>
                  </div>
                </div>
                <div className="flex gap-2 flex-wrap"></div>
                <p class="mt-2 text-sm text-red-5">{error}</p>
              </div>
            )}
          </div>
        </ResizablePanel>
        {templateType !== enums?.templateTypes.no_preview.id && (
          <>
            <ResizableHandle withHandle={true} />
            <ResizablePanel defaultSize={70} minSize={40}>
              <div class="w-full pt-5">
                <DeviceEmulator
                  isLandscapeSupport={isLandscapeSupport}
                  platformType={templatePlatform}
                >
                  {(props) => (
                    <DeviceFrameset {...props}>
                      <HtmlViewerWithInspector
                          htmlCode={htmlCode || selectedTemplate?.html || ""}
                          cssCode={cssCode || selectedTemplate?.css || ""}
                          experience_json={getExperienceJSON(JSON.parse(configJsonCode || selectedTemplate?.config_json || "[]"))}
                          configJsonData={[]}
                          configFieldNameMain={null}
                          inspectorEnabled={false}
                          onElementUpdate={() => {}}
                          web_url={""}
                          templateType={templateType}
                      />
                    </DeviceFrameset>
                  )}
                </DeviceEmulator>
              </div>
            </ResizablePanel>
          </>
        )}
      </ResizablePanelGroup>
      {
        levelModal && <CreateTemplateLevelModal setLevelModal={setLevelModal} saveTemplateHandler={saveTemplateHandler} levels={levels} setLevels={setLevels} />
      }
    </div>
  );
};

export default PreviewTemplate;
